if (!customElements.get('vt-sticky-button-style')) {
  customElements.define('vt-sticky-button-style', class extends HTMLElement {
    connectedCallback() {
      this.sync = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateStyle());
      };
      this.source = document.getElementById('ProductSubmitButton-' + this.dataset.section);
      this.sticky = this.closest('sticky-atc');
      this.button = this.sticky?.querySelector('.sticky-atc__add_button');
      if (!this.source || !this.button) return;
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.source, {attributes: true, childList: true, subtree: true});
      window.addEventListener('resize', this.sync, {passive: true});
      this.sync();
    }
    updateStyle() {
      if (!this.source?.isConnected || !this.button?.isConnected) return;
      const style = getComputedStyle(this.source);
      const scale = 44 / Math.max(44, parseFloat(style.minHeight) || 52);
      const values = {
        '--vt-sticky-background': style.backgroundColor,
        '--vt-sticky-color': style.color,
        '--vt-sticky-family': style.fontFamily,
        '--vt-sticky-font-size': (parseFloat(style.fontSize) * scale) + 'px',
        '--vt-sticky-weight': style.fontWeight,
        '--vt-sticky-font-style': style.fontStyle,
        '--vt-sticky-radius': (parseFloat(style.borderRadius) * scale) + 'px',
        '--vt-sticky-letter-spacing': style.letterSpacing,
        '--vt-sticky-transform': style.textTransform
      };
      const label = this.source.querySelector('.button__label');
      if (label) values['--vt-sticky-gap'] = getComputedStyle(label).columnGap;
      const sourceIcon = this.source.querySelector('.vt-button-icon');
      const targetIcon = this.button.querySelector('.vt-button-icon');
      if (sourceIcon) {
        values['--vt-sticky-icon-size'] = (parseFloat(getComputedStyle(sourceIcon).width) * scale) + 'px';
        if (targetIcon?.innerHTML !== sourceIcon.innerHTML) {
          if (targetIcon) targetIcon.replaceWith(sourceIcon.cloneNode(true));
          else this.button.querySelector('.sticky-atc__label')?.prepend(sourceIcon.cloneNode(true));
        }
      } else targetIcon?.remove();
      for (const [name, value] of Object.entries(values)) {
        if (this.sticky.style.getPropertyValue(name) !== value) this.sticky.style.setProperty(name, value);
      }
      const buttonColor = style.getPropertyValue('--color-button');
      if (buttonColor) this.button.style.setProperty('--color-button', buttonColor);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.sync);
      cancelAnimationFrame(this.frame);
    }
  });
}
